import styled from 'styled-components';

export const StyledShareBadge = styled.div`
    background: #F5F5F5;
    color: #949DA5;
    padding: 0 12px;
    border-radius: 14px;
    font-size: 1.2rem;
    font-family: 'Verdana', sans-serif;
    font-weight: normal;
    margin-top: -10px;
    display: inline-block;
    position: relative;
    top: -5px;
    left: 7px;
`;